<template xmlns="http://www.w3.org/1999/html" xmlns="http://www.w3.org/1999/html">
  <div id="meeting-form">
    <form>
      <h5> Current meeting timezone: {{this.$store.state.TimeZone.timeZoneId}} </h5>
      <label class="input-label" for="normalSelect">Meeting timezone: *</label>
      <select @change="changeTimezone(timeZoneId)" id="normalSelect" class="normalSelect" v-model="timeZoneId">
<!--        <option value="initial" disabled>Please select your Meeting Timezone</option>-->
        <option selected value="current">Current/Browser TimeZone</option>
        <option
            value="America/Detroit"
        >Eastern Time - (UTC {{getZoneOffset("America/Detroit")}})</option>
        <option
            value="America/Indiana/Vevay"
        >Eastern Time (no daylight savings) - (UTC {{getZoneOffset("America/Indiana/Vevay")}})</option>
        <option
            value="America/Chicago"
        >Central Time - (UTC {{getZoneOffset("America/Chicago")}})</option>
        <option
            value="America/Phoenix"
        >Mountain Time (no daylight savings) - (UTC {{getZoneOffset("America/Phoenix")}})</option>
        <option value="America/Denver">Mountain Time - (UTC {{getZoneOffset("America/Denver")}})</option>
        <option
            value="America/Los_Angeles"
        >Pacific Time - (UTC {{getZoneOffset("America/Los_Angeles")}})</option>
        <option
            value="America/Anchorage"
        >Alaska Time - (UTC {{getZoneOffset("America/Anchorage")}})</option>
        <option
            value="Pacific/Honolulu"
        >Hawaii-Aleutian Time - (UTC {{getZoneOffset("Pacific/Honolulu")}})</option>
      </select>
<!--      <select-->
<!--        id="meetingEvent"-->
<!--        class="normalSelect"-->
<!--        v-model="localMeetingData.event.eventId"-->
<!--        @change="setStartEnd(localMeetingData.event.eventId)"-->
<!--      >-->
<!--        <option-->
<!--          v-for="meetingEvent in allEvents"-->
<!--          :key="meetingEvent.classCalendarID"-->
<!--          :value="meetingEvent.classCalendarID"-->
<!--          :selected="meetingEvent"-->
<!--        >-->
<!--          <span style="font-weight: bold">{{ meetingEvent.eventName }}</span>-->
<!--          - -->
<!--          {{-->
<!--            moment-->
<!--              .unix(meetingEvent.scheduleDetails.unix_start_time)-->
<!--              .format("MMMM Do YYYY")-->
<!--          }}-->
<!--        </option>-->
<!--      </select>-->

      <label class="input-label" for="title">Meeting title: *</label>
      <input
        type="text"
        id="title"
        v-model="$v.localMeetingData.title.$model"
        :class="status($v.localMeetingData.title)"
      />

      <label class="input-label" for="description">Meeting description:</label>
      <textarea
        rows="5"
        id="description"
        v-model="localMeetingData.description"
      ></textarea>

      <div class="form-2-holder">
        <div>
          <label class="input-label" for="startTime"
            >Start time (in Core Groups TimeZone): *</label
          >
          <datetime
            class="theme-meeting"
            id="startTime"
            type="datetime"
            use12-hour
            auto
            value-zone="UTC"
            :zone="this.$store.state.TimeZone.timeZoneId"
            v-model="localMeetingData.meetingStartTime"
            :minute-step="state.setMinuteStep"
            :min-datetime="state.minStart"
            :week-start="7"
          ></datetime>
        </div>
        <div>
          <label class="input-label" for="endTime"
            >End time (in Core Groups TimeZone): *</label
          >
          <datetime
            class="theme-meeting"
            id="endTime"
            type="datetime"
            use12-hour
            auto
            value-zone="UTC"
            :zone="this.$store.state.TimeZone.timeZoneId"
            v-model="localMeetingData.meetingEndTime"
            :minute-step="state.setMinuteStep"
            :min-datetime="localMeetingData.meetingStartTime"
            :max-datetime="setMaxEnd"
            :week-start="7"
          ></datetime>
        </div>
      </div>

      <label class="input-label" for="meetingPlatform"
        >Meeting platform: *</label
      >
      <select
        id="meetingPlatform"
        class="normalSelect"
        v-model="localMeetingData.platformId"
      >
        <option
          v-for="meetingPlatform in meetingPlatforms"
          :value="meetingPlatform.id"
          :key="meetingPlatform.id"
          :selected="meetingPlatform == ''"
        >
          {{ meetingPlatform.name }}
        </option>
      </select>

      <template
        v-if="
          localMeetingData.platformId === 2
        "
      >
        <label class="input-label" for="title">Platform name:</label>
        <input
          type="text"
          id="plat"
          v-model="state.platformName"
          @input="state.platformName = $event.target.value"
        />

        <label class="input-label" for="title">Meeting link: *</label>
        <input
          type="text"
          id="meeting-link"
          v-model="localMeetingData.MeetingJoinLink"
          @input="localMeetingData.MeetingJoinLink = $event.target.value"
        />
      </template>

<!--      <label-->
<!--        class="input-label"-->
<!--        for="visitor"-->
<!--        style="line-height: initial; margin-bottom: 8px; margin-top: 8px"-->
<!--      >-->
<!--        Visitors (you can add multiple email addresses separated by semicolon):-->
<!--      </label>-->
<!--      <input type="text" id="visitor" v-model="visitorHolder" />-->
<!--      <button class="addVisitorBtn" type="button" @click="handleVisitors">-->
<!--        Add Visitors-->
<!--      </button>-->

<!--      <div id="resend-email">-->
<!--        <div v-for="(item, index) in localMeetingData.visitors" :key="index">-->
<!--          <div class="horiz-align-items">-->
<!--            <div class="personImage-holder">-->
<!--              <img-->
<!--                class="personImage"-->
<!--                alt="profile"-->
<!--                src="../../assets/profile-icon.png"-->
<!--              />-->
<!--            </div>-->
<!--            <div class="vertical-align-items">-->
<!--              <label class="user-email-text">{{ item.email }}</label>-->
<!--            </div>-->
<!--            <div class="button-holder">-->
<!--              <button-->
<!--                type="button"-->
<!--                class="delete"-->
<!--                @click="deleteFromVisitorList(index)"-->
<!--              >-->
<!--                Remove-->
<!--              </button>-->
<!--            </div>-->
<!--          </div>-->
<!--          <hr />-->
<!--        </div>-->
<!--      </div>-->

<!--      <template v-if="this.getMeetingModalType === 'edit'">-->
<!--        <button-->
<!--          class="createMeetingBtn"-->
<!--          type="button"-->
<!--          @click="this.toggleResendInvitationDiv"-->
<!--        >-->
<!--          Resend user invitations-->
<!--        </button>-->
<!--        <div v-if="!this.state.isHidden">-->
<!--          <div id="resend-email">-->
<!--            <h3>Resend invitation</h3>-->
<!--            <h4>Resend invitation emails to your core group members</h4>-->
<!--            <label class="side-text">Invited</label>-->
<!--            <div v-for="member in getCoreGroupMembers" :key="member.personID">-->
<!--              <div class="horiz-align-items">-->
<!--                <div class="personImage-holder">-->
<!--                  <img-->
<!--                    alt="profile"-->
<!--                    v-if="-->
<!--                      member.profilePicDetails &&-->
<!--                      member.profilePicDetails.length > 0-->
<!--                    "-->
<!--                    class="personImage"-->
<!--                    :src="-->
<!--                      'https://fisher.communitybiblestudy.org/Images/PeoplePictures/' +-->
<!--                      member.profilePicDetails[0].filePath-->
<!--                    "-->
<!--                  />-->
<!--                  <img-->
<!--                    alt="profile"-->
<!--                    v-else-->
<!--                    class="personImage"-->
<!--                    src="../../assets/profile-icon.png"-->
<!--                  />-->
<!--                </div>-->
<!--                <div class="vertical-align-items">-->
<!--                  <label class="user-name-text"-->
<!--                    >{{ member.firstName }} {{ member.lastName }}</label-->
<!--                  >-->
<!--                  <label class="user-email-text">{{ member.email }}</label>-->
<!--                </div>-->
<!--                <div class="button-holder">-->
<!--                  <button-->
<!--                    type="button"-->
<!--                    @click="resendInvitation(member, $event)"-->
<!--                  >-->
<!--                    Resend invitation-->
<!--                  </button>-->
<!--                </div>-->
<!--              </div>-->
<!--              <hr />-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </template>-->
      <button
        v-if="getMeetingModalType === 'create'"
        class="createMeetingBtn"
        type="button"
        @click.prevent="submitForm"
      >
        Create meeting
      </button>
      <button
        v-if="getMeetingModalType === 'edit'"
        class="createMeetingBtn"
        type="button"
        @click.prevent="submitForm"
      >
        Edit meeting
      </button>
    </form>
  </div>
</template>

<script>
/* eslint-disable no-debugger */
/* eslint-disable no-unused-vars */
import { Datetime } from "../../../node_modules/vue-datetime";
import "../../../node_modules/vue-datetime/dist/vue-datetime.min.css";
import meetingService from "../../services/MeetingService";
import { mapGetters, mapActions, mapMutations } from "vuex";
import Multiselect from "vue-multiselect";
import { required, minLength } from "vuelidate/lib/validators";
import MomentTZ from "moment-timezone";
import store from "@/store";
import Moment from "moment";

export default {
  name: "MeetingForm",
  components: {
    Datetime,
    Multiselect,
  },
  data() {
    return {
      timeZoneId: "current",
      localMeetingData: {
        title: "",
        description: "",
        meetingStartTime: "",
        meetingEndTime: "",
        platformId: 0,
        reminder: false,
        createdBy: 0,
        personId: 0,
        UpdatedBy: 0,
        MeetingJoinLink: "",
        timeZoneOffset: 0,
        timeZone: "",
      },
      meetingPlatforms: [
        { id: 1, name: "Zoom (Provided by CBS)" },
        { id: 2, name: "Other (Bring your own)" },
      ],
      state: {
        today: "",
        setMinuteStep: 5,
        platformName: "",
        minStart: "",
        maxEnd: "",
        setMaxEnd: "",
        isHidden: true,
      },
      visitorHolder: "",
      allEvents: [],
      filteredMembers: [],
    };
  },
  validations: {
    localMeetingData: {
      title: {
        required,
        minLength: minLength(5),
      },
      meetingStartTime: {
        required,
      },
      meetingEndTime: {
        required,
      },
      MeetingJoinLink: {
        required,
        minLength: minLength(5),
      },
    },
  },
  methods: {
    ...mapActions(["fetchCoreGroup", "fetchMeetings", "resendEmail"]),
    ...mapMutations(["toggleModal", "setTimeZone"]),
    status(validation) {
      return {
        error: validation.$error,
      };
    },

    // handleVisitors() {
    //   let temp = this.visitorHolder.split(";");
    //   console.log(temp);
    //   if (this.checkVisitorsEmail(temp)) {
    //     for (const item of temp) {
    //       var o = { email: item.trim() };
    //       console.log(JSON.parse(JSON.stringify(o)));
    //       console.log(JSON.stringify(o));
    //       this.localMeetingData.visitors.push(JSON.parse(JSON.stringify(o)));
    //     }
    //     //temp.forEach( v => {
    //     //  let o = new {email : v.trim()}
    //     //  this.localMeetingData.visitors.push(o);
    //     //});
    //     console.log(this.localMeetingData.visitors);
    //     console.log(this.localMeetingData.visitors2);
    //     this.visitorHolder = "";
    //   } else {
    //     alert("Visitors emails are not correct!");
    //   }
    // },
    // deleteFromVisitorList(index) {
    //   this.localMeetingData.visitors.splice(index, 1);
    //   console.log(this.localMeetingData.visitors);
    // },
    // checkVisitorsEmail(emails) {
    //   if (emails.length > 0) {
    //     for (const item of emails) {
    //       if (!this.validEmail(item.trim())) {
    //         return false;
    //       }
    //     }
    //     return true;
    //   } else {
    //     return true;
    //   }
    // },
    // validEmail: function (email) {
    //   var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //   return re.test(email);
    // },
    submitForm() {
      this.changeTimezone(this.timeZoneId);
      if (
        this.localMeetingData.timeZone !== "" &&
        this.localMeetingData.title !== "" &&
        this.localMeetingData.meetingStartTime !== "" &&
        this.localMeetingData.meetingEndTime !== "" &&
        this.localMeetingData.platformId > 0
      ) {
        if (this.localMeetingData.platformId === 2) {
          if (this.localMeetingData.MeetingJoinLink !== "") {
            this.startCreateMeeting();
          } else {
            this.$confirm({
              message: "Please fill all the required fields!",
              button: {
                yes: "Ok",
              },
            });
          }
        } else if (
          this.localMeetingData.timeZone.exists === false ||
          this.$store.state.TimeZone.timeZoneId === null
        ) {
          this.$confirm({
            message:
              "Your TimeZone is not valid! Please update your TimeZone in order to create a meeting!",
            button: {
              yes: "Ok",
            },
          });
        } else {
          this.startCreateMeeting();
        }
      } else {
        this.$confirm({
          message: "Please fill all the required fields!",
          button: {
            yes: "Ok",
          },
        });
      }
    },
    startCreateMeeting() {
      if (this.getMeetingModalType === "create") {
        this.$confirm({
          message:
            "Would you like to create this meeting?",
          button: {
            no: "No",
            yes: "Yes",
          },

          callback: (confirm) => {
            if (confirm) {
              // this.localMeetingData.coreGroupId = Number(
              //   this.$store.state.coreGroupId
              // );
              this.localMeetingData.createdBy = Number(
                this.$store.state.personId
              );
              this.localMeetingData.personId = Number(
                  this.$store.state.personId
              );

              this.localMeetingData.timeZoneOffset = new Date().getTimezoneOffset();
              meetingService
                .createMeeting(this.localMeetingData)
                .then((result) => {
                  this.$store.state.Meetings.localMeetingData = this.$store.state.Meetings.initialMeetingData;
                  this.$store.commit("toggleModal");
                  this.fetchMeetings(this.$store.state.personId);
                });
            }
          },
        });
      } else if (this.getMeetingModalType === "edit") {
        this.$confirm({
          message:
            "Would you like to update this meeting?",
          button: {
            no: "No",
            yes: "Yes",
          },

          callback: (confirm) => {
            if (confirm) {
              this.localMeetingData.UpdatedBy = Number(
                this.$store.state.personId
              );
              this.localMeetingData.personId = Number(
                  this.$store.state.personId
              );
              this.localMeetingData.timeZoneOffset = new Date().getTimezoneOffset();
              meetingService.updateMeeting(
                this.localMeetingData.meetingId,
                this.localMeetingData
              );
            }
          },
        });
      }
    },
    firstLastname({ firstName, lastName }) {
      return `${firstName} ${lastName}`;
    },
    getZoneOffset(timezone) {
      return MomentTZ().tz(timezone).format("Z");
    },
    currentTimezone() {
      var zone =  Moment.tz.guess();
      console.log(zone);
      this.setTimeZone(zone);
      return zone;
    },
    changeTimezone(zone) {
      if (zone === "current") {
        zone = this.currentTimezone();
      }
      this.setTimeZone(zone);
      this.localMeetingData.timeZone = zone;
    },
    // filterOldEvents(allEvents) {
    //   let filteredEvents = [];
    //   let currentTimeMin = this.moment().add(-24, "hours").format("X");
    //   allEvents.forEach((event) => {
    //     if (event.scheduleDetails.unix_start_time > currentTimeMin) {
    //       if (event.eventTypeID !== 4) {
    //         filteredEvents.push(event);
    //       }
    //     }
    //   });
    //   console.log("filteredEVEnts", filteredEvents);
    //   this.allEvents = filteredEvents;
    // },
    // setStartEnd(eventId) {
    //   const allEvents = this.$store.state.events;
    //   let chosenEvent = {};
    //   allEvents.forEach((element) => {
    //     if (element.classCalendarID === eventId) {
    //       chosenEvent = element;
    //     }
    //   });
    //   console.log("CHOSEN EVENT", chosenEvent);
    //   this.state.minStart = this.moment
    //     .unix(chosenEvent.scheduleDetails.unix_start_time)
    //     .local()
    //     .add(-7, "days")
    //     .toISOString();
    //   this.state.maxEnd = this.moment
    //     .unix(chosenEvent.scheduleDetails.unix_start_time)
    //     .local()
    //     .add(7, "days")
    //     .toISOString();
    // },
    // resendInvitation(member, event) {
    //   event.target.disabled = true;
    //   event.target.classList.toggle("grey-out");
    //
    //   this.resendEmail({
    //     meetingId: this.getMeetingToEdit.meetingId,
    //     member: member,
    //     primaryLeaderMail: this.getCoreGroup.primaryLeader.email,
    //   }).then((response) => {
    //     console.log("Axios POST call finished with status: ", response.status);
    //   });
    // },
    // toggleResendInvitationDiv() {
    //   this.state.isHidden = !this.state.isHidden;
    // },
    // filterCoreGroupMembers() {
    //   let filteredHostList = [];
    //   this.getCoreGroupMembers.forEach((member) => {
    //     if (
    //       member.email &&
    //       member.isAdult === true &&
    //       Number(member.personID) !== Number(this.$store.state.personId)
    //     ) {
    //       filteredHostList.push(member);
    //     }
    //   });
    //   this.filteredMembers = filteredHostList;
    // },
  },
  computed: {
    ...mapGetters([
      // "getCoreGroupMembers",
      "meetingData",
      "getMeetingModalType",
      "getMeetingToEdit",
      // "getCoreGroup",
    ]),
    setMaxEnd: function () {
      return this.moment(this.localMeetingData.meetingStartTime).add(12, "hours").toISOString();
    },
    timeZoneIdComp: function () {
      console.log(String(store.state.TimeZone.timeZoneId));
      if (String(store.state.TimeZone.timeZoneId) !== "null") {
        return store.state.TimeZone.timeZoneId;
      } else {
        return "initial";
      }
    },

  },
  created: function () {
    this.state.today = new Date().toISOString();
    this.state.minStart = new Date().toISOString();
    // this.fetchCoreGroup();
    // this.filterOldEvents(this.$store.state.events);
  },
  beforeMount() {
    if (this.getMeetingModalType === "edit") {
      const startTime = MomentTZ.utc(this.meetingData.meetingStartTime)
        .tz(this.$store.state.TimeZone.timeZoneId)
        .toISOString();
      const endTime = MomentTZ.utc(this.meetingData.meetingEndTime)
        .tz(this.$store.state.TimeZone.timeZoneId)
        .toISOString();
      this.localMeetingData = this.meetingData;
      this.localMeetingData.meetingStartTime = startTime;
      this.localMeetingData.meetingEndTime = endTime;
    } else {
      // this.localMeetingData.event.eventId = this.$store.state.eventDisplay.classCalendarID;
    }
    // this.filterCoreGroupMembers();
  },
  mounted() {
    // if (this.$store.state.eventDisplay.classCalendarID) {
    //   console.log("eventID", this.$store.state.eventDisplay.classCalendarID);
    //   this.setStartEnd(this.$store.state.eventDisplay.classCalendarID);
    // }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped src="@/styles/style-modal.scss">
</style>
<style lang="scss">
.vdatetime-input {
  display: inline-block;
  width: 100%;
  padding: 0 17px;
  border: 0.8px solid #c4c4c4;
  box-sizing: border-box;
  border-radius: 5px;
  height: 35px;
  resize: vertical;
  outline: none;
  background: transparent;
  background-image: url("../../assets/icon-calendar.png");
  background-repeat: no-repeat;
  background-position-x: 95%;
  background-position-y: 10px;
}
.vdatetime-overlay {
  background: rgba(0, 0, 0, 0.2);
  transition: opacity 0.5s;
  border-radius: 15px;
}
.theme-meeting {
  & .vdatetime-popup__header,
  & .vdatetime-calendar__month__day--selected > span > span,
  & .vdatetime-calendar__month__day--selected:hover > span > span {
    background: #2568a3;
  }

  & .vdatetime-year-picker__item--selected,
  & .vdatetime-time-picker__item--selected,
  & .vdatetime-popup__actions__button {
    color: #2568a3;
  }
}
.multiselect__tag {
  background: #f3f3f3;
}
.multiselect__tag-icon:after {
  color: #c87878;
}
.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background: #c87878;
}
.multiselect__option--highlight::after,
.multiselect__option--highlight {
  background-color: #bedbce;
}
.multiselect__option.multiselect__option--highlight.multiselect__option--selected::after,
.multiselect__option--selected.multiselect__option--highlight {
  background: #e4c2c2;
}
.multiselect__option.multiselect__option--highlight.multiselect__option--selected::after {
  content: "Remove";
  font-weight: normal;
}
.multiselect__option--selected::after {
  font-weight: normal;
}
.multiselect__option--highlight::after {
  content: "Select";
}
.multiselect__input,
.multiselect__single,
.multiselect__option {
  font-size: 13px;
}
</style>
